module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/ogp-1a09f0b7c02f74f3837dbc26e3b1d0d6.webp";